import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditMetadataExpressionById} from '../metadataEditSlice';
import {useCreateSelectorById} from './useCreateSelectorById';
import type {ExpressionV4} from '../types';

export const useMetadataEditExpression = (
  expressionId: string,
  verifyExists: boolean,
): ExpressionV4 | undefined => {
  const selector = useCreateSelectorById(
    expressionId,
    selectMetadataEditMetadataExpressionById,
  );
  const expression = useAppSelector(selector);

  if (verifyExists && !expression) {
    assert(false, 'useMetadataEditExpression: unknown expressionId', {
      expressionId,
    });
  }

  return expression;
};
